import { render, staticRenderFns } from "./createQuoteStep1.vue?vue&type=template&id=2f8ef042&scoped=true&"
import script from "./createQuoteStep1.vue?vue&type=script&lang=js&"
export * from "./createQuoteStep1.vue?vue&type=script&lang=js&"
import style0 from "./createQuoteStep1.vue?vue&type=style&index=0&id=2f8ef042&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8ef042",
  null
  
)

export default component.exports